export default __webpack_public_path__ + "static/media/SEO.160f94bf.png";